
interface App {
  id: string;
  bundle_id: string;
  app_name: string;
  app_icon_url?: string;
  version_code?: string;
  category?: string;
  tags: string[];
  tag_ids?: string[];
  description?: string;
  created_at: string;
  updated_at: string;
}

interface AppDescriptionProps {
  app: App;
}

export const AppDescription = ({ app }: AppDescriptionProps) => {
  return (
    <div>
      <label className="text-sm font-medium text-gray-700 mb-2 block">Description</label>
      <div className="bg-gray-50 rounded-lg p-4">
        {app.description ? (
          <p className="text-sm text-gray-700 leading-relaxed whitespace-pre-wrap">
            {app.description}
          </p>
        ) : (
          <p className="text-gray-400 italic text-sm">No description available</p>
        )}
      </div>
    </div>
  );
};
